
export const BASE_API_URL = 'https://barker-service-5qddxc5llq-uc.a.run.app/v1/';
